<div class="property-card">
  <div class="image-container">
    <img
      [src]="propertyData?.mediaGroup?.[0]?.url || 'https://via.placeholder.com/300x200?text=No+Image'"
      alt="Property Image"
      class="Images"
    />
  </div>

  <div class="property-details">
    <h3>{{ propertyData?.title }}</h3>

    <div class="location-row">
      <p class="location">
        <i class="fa fa-map-marker"></i>
        {{ propertyData?.address }}, {{ propertyData?.area }}, {{ propertyData?.cityName }}
      </p>
      <span class="size-info">
        <i class="fa fa-arrows-alt"></i> {{ propertyData?.buildupArea || '200' }} Sqft
      </span>
    </div>

<div class="price">
  ₹{{ propertyData?.propertyRentPrice || 10000 }}
  <span *ngIf="propertyData?.rentPerMonth">/Month</span>

  <button class="view-button" (click)="viewDetails(propertyData?.id, $event)">View Details</button>
</div>

  </div>

  <!-- View button outside image-container, bottom right of card -->
</div>
